export enum YesNo {
  Yes = 1,
  No = 0,
}
